import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "goal-details" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-10\"><nav class=\"flex space-x-4\" aria-label=\"Tabs\"><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-semibold text-sm rounded-md bg-sienna-100 text-neutral-700 cursor-pointer\"> Vận động thô </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Vận động tinh </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Giao tiếp </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Toán </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Viết </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Đọc </div><div class=\"text-neutral-500 hover:text-neutral-700 px-3 py-2 font-medium text-sm rounded-md cursor-pointer\"> Hành vi &amp; Giác quans </div></nav></div><div class=\"p-6 bg-white shadow-sm rounded-2xl mb-10\"><div class=\"flex items-center justify-between\"><div class=\"font-semibold text-neutral-600 mb-6\"> Vận động thô </div><div><select class=\"mt-1 block w-full pl-3 pr-10 py-2 text-base border-neutral-300 rounded-md\"><option>Mục tiêu 1</option><option selected>Mục tiêu 2</option><option>Mục tiêu 3</option></select></div></div><div class=\"border border-neutral-200 mt-6 rounded-md\"><div class=\"py-4 px-4 grid grid-cols-4\"><dt class=\"text-sm font-semibold text-neutral-400\"> Nội dung </dt><dd class=\"mt-1 text-sm text-gray-900 col-span-3 font-bold\"> Đi trên mặt phẳng nghiêng có bám vịn đạt 80% </dd></div><div class=\"py-4 px-4 grid grid-cols-4\"><dt class=\"text-sm font-semibold text-neutral-400\"> Cơ sở hợp lý </dt><dd class=\"mt-1 text-sm text-gray-900 col-span-3\"> Giúp trẻ biết giữ thăng bằng cơ thể cũng như sự khéo léo của chân, phối hợp cử động chân, tay và mắt. </dd></div><div class=\"py-4 px-4 grid grid-cols-4\"><dt class=\"text-sm font-semibold text-neutral-400\"> Chiến lược </dt><dd class=\"mt-1 text-sm text-gray-900 col-span-3\"> Làm mẫu <br> Trợ giúp/ xóa giúp. <br> Khen thưởng <br> Cổ vũ <br></dd></div><div class=\"py-4 px-4 grid grid-cols-4\"><dt class=\"text-sm font-semibold text-neutral-400\"> Quy trình thực hiện </dt><dd class=\"mt-1 text-sm text-gray-900 col-span-3\"> Đi ngược lên cầu trượt. <br> Đi trên tấm ván lấy đồ </dd></div></div></div>", 2)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between\"><div class=\"text-neutral-600 font-semibold\">Tháng 9 / 2021</div><div class=\"flex items-center flex-nowrap ml-4\"><div class=\"text-neutral-500 mr-2\">Mục tiêu lặp lại</div><div class=\"h-5 w-5 rounded-full\" style=\"background:#eacece;\"></div></div></div>", 1)
const _hoisted_5 = { class: "shadow-sm sm:rounded-2xl mt-10 overflow-hidden" }
const _hoisted_6 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_7 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_8 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " Loại "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider",
      style: {"min-width":"160px"}
    }, " Nội dung "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " 3 buổi gần nhất "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-32" })
  ])
], -1)
const _hoisted_10 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700 flex items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "h-5 w-5 rounded-full ml-3",
  style: {"background":"#eacece"}
}, null, -1)
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white mr-4 shadow-input",
      style: {"background":"#2aa797"}
    }, " > 75% "),
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white mr-4 shadow-input",
      style: {"background":"#2aa797"}
    }, " > 75% "),
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white shadow-input",
      style: {"background":"#2aa797"}
    }, " > 75% ")
  ])
], -1)
const _hoisted_15 = { class: "flex flex-nowrap items-center" }
const _hoisted_16 = { class: "p-2" }
const _hoisted_17 = { class: "mt-10" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between\"><div class=\"text-neutral-600 font-semibold\">Tháng 9 / 2021</div><div class=\"flex items-center flex-nowrap ml-4\"><div class=\"text-neutral-500 mr-2\">Mục tiêu lặp lại</div><div class=\"h-5 w-5 rounded-full\" style=\"background:#eacece;\"></div></div></div>", 1)
const _hoisted_19 = { class: "shadow-sm sm:rounded-2xl mt-10 overflow-hidden" }
const _hoisted_20 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_21 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_22 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " Loại "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " Nội dung "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
    }, " 3 buổi gần nhất "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-32" })
  ])
], -1)
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_25 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700 flex items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "h-5 w-5 rounded-full ml-3 shadow-input",
  style: {"background":"#eacece"}
}, null, -1)
const _hoisted_27 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white mr-4",
      style: {"background":"#2aa797"}
    }, " > 75% "),
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white mr-4",
      style: {"background":"#2aa797"}
    }, " > 75% "),
    /*#__PURE__*/_createElementVNode("span", {
      class: "inline-flex items-center px-3 py-0.5 rounded-full text-sm font-semibold text-white",
      style: {"background":"#2aa797"}
    }, " > 75% ")
  ])
], -1)
const _hoisted_29 = { class: "flex flex-nowrap items-center" }
const _hoisted_30 = { class: "p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (person, personIdx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: person.id,
                    class: _normalizeClass([
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									, "text-neutral-700"])
                  }, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("div", null, _toDisplayString(person.id), 1)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", null, _toDisplayString(person.type), 1),
                      _hoisted_12
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", null, _toDisplayString(person.content), 1)
                    ]),
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_router_link, { to: "/goal-management/1/skill-details/2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DaIcon, {
                                name: "das--chevron-down",
                                class: "h-4 w-4 text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer transform -rotate-90"
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (person, personIdx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: person.id,
                    class: _normalizeClass([
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									, "text-neutral-700"])
                  }, [
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", null, _toDisplayString(person.id), 1)
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", null, _toDisplayString(person.type), 1),
                      _hoisted_26
                    ]),
                    _createElementVNode("td", _hoisted_27, [
                      _createElementVNode("div", null, _toDisplayString(person.content), 1)
                    ]),
                    _hoisted_28,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_router_link, { to: "/goal-management/1/skill-details/2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DaIcon, {
                                name: "das--chevron-down",
                                class: "h-4 w-4 text-blue-600 hover:text-blue-900 active:text-blue-500 cursor-pointer transform -rotate-90"
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}